import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements OnInit {
  @HostBinding('class') hostClass = 'top-bar';
  @Input() title: string;
  @Input() hideSubMenu: boolean;
  @Input() titleBeta: boolean;
  public showSubMenu: boolean;

  constructor() {}

  ngOnInit() {}
}
